import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar.svg";
import Tilt from "react-parallax-tilt";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
              I am a full-stack software engineer based in Rabat, Morocco,
              with 4 years of experience building SaaS web applications,
              responsive product interfaces, backend APIs, and production-ready
              features.
              <br />
              <br />
              I am proficient in
              <i>
                <b className="purple">
                  {" "}
                  React, Next.js, TypeScript, Node.js, PostgreSQL, and AWS{" "}
                </b>
              </i>
              - and I enjoy working across both frontend and backend systems.
              <br />
              <br />
              My work focuses on
              <i>
                <b className="purple">
                  {" "}
                  dashboards, REST APIs, performance optimization,
                  authentication, testing, and clean product delivery{" "}
                </b>
              </i>
              for businesses that need reliable web applications.
              <br />
              <br />
              Whenever possible, I build with
              <b className="purple"> React </b> and modern frameworks like{" "}
              <i>
                <b className="purple">Next.js</b>,{" "}
                <b className="purple">Express.js</b>, and{" "}
                <b className="purple">Prisma</b>.
              </i>
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
